// This helper was created as an alternative to the built-in FreshworksWidget functions
// The reason being that the built-in functions aren't working on iPhone for some strange reason
export class FreshworksHelper {
  static hideWidget() {
    const element = document.getElementById("launcher-frame");
    if (element) {
      element.style.display = "none";
    }
  }
  static showWidget() {
    const element = document.getElementById("launcher-frame");
    if (element) {
      element.style.display = "block";
    }
  }
}
